var resizeObservers=[];export{resizeObservers};